import { MAUVAISE_INSTABLE_BONNE_EXCELLENTE } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case MAUVAISE_INSTABLE_BONNE_EXCELLENTE.MAUVAISE:
        return 'Mauvaise';
      case MAUVAISE_INSTABLE_BONNE_EXCELLENTE.INSTABLE:
        return 'Instable';
      case MAUVAISE_INSTABLE_BONNE_EXCELLENTE.BONNE:
        return 'Bonne';
      case MAUVAISE_INSTABLE_BONNE_EXCELLENTE.EXCELLENTE:
        return 'Excellente';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/filters/mauvaise-instable-bonne-excellente.filter.js